import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSettings$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSettings extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a3a2d1abade85fd20d9b7c6fb95c7d0fc360ee36', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a5ce550252dafb74cb9ac7c41af4a4fafd8b5cc4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '43ce9b51f42c35cfd38f7a582d4e545c2cd26d3d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.782 10.942a7 7 0 0 0-.044-.733l1.64-1.765a.44.44 0 0 0 .063-.53L17.329 6.01a.43.43 0 0 0-.486-.212l-2.312.547a6 6 0 0 0-1.297-.697l-.688-2.294A.43.43 0 0 0 12.123 3H9.89a.44.44 0 0 0-.423.318l-.689 2.33q-.695.267-1.306.696L5.17 5.797a.44.44 0 0 0-.485.212L3.572 7.933a.45.45 0 0 0 .062.529l1.641 1.765a6 6 0 0 0 0 1.465l-1.641 1.764a.45.45 0 0 0-.062.53l1.112 1.923a.44.44 0 0 0 .485.212l2.303-.582c.403.288.842.523 1.306.697l.689 2.294a.44.44 0 0 0 .423.318h2.233a.43.43 0 0 0 .423-.318l.688-2.294a5.7 5.7 0 0 0 1.297-.697l2.33.547a.43.43 0 0 0 .485-.212l1.112-1.924a.44.44 0 0 0-.062-.529l-1.64-1.765a7 7 0 0 0 .026-.714m-5.78 4.147a4.147 4.147 0 1 1 0-8.295 4.147 4.147 0 0 1 0 8.295", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-settings", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-settings"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-settings":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSettings$1);
            }
            break;
    } });
}

const CosmosIconSettings = CosmosIconSettings$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSettings, defineCustomElement };
